<template>
  <div class="itemm">
    <div class="lab">{{ type === 1 ? '环比：' : '同比：' }}</div>
    <div class="val">{{ num }}%</div>
    <div class="ico" :class="[num < 0 ? 'down' : '', num > 0 ? 'up' : '']"></div>
  </div>
</template>

<script>
export default {
  name: "TongBi",
  props: {
    type: Number,
    num: [String, Number],
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="less" scoped>
.itemm {
  display: flex;
  align-items: center;

  .lab {
    font-size: 12px;
    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
    font-weight: 400;
    color: #969AA1;
  }

  .val {
    font-size: 12px;
    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
    font-weight: 400;
    color: #F3F9FF;
  }

  .ico {
    width: 8px;
    height: 10px;
    margin: 0 15px 0 5px;

    &.up {
      background: url(../assets/img/icon_totper_01.png) no-repeat center center;
    }

    &.down {
      background: url(../assets/img/icon_totper_02.png) no-repeat center center;
    }
  }
}
</style>
